import SingleWidgetManager from '@hubbox/single-widget-manager'

export default (): void => {
  const hubboxButton = document.getElementById('hubbox-button')

  if (hubboxButton === null) return

  const iframeUrl = process.env.RAILS_ENV === 'production' ? SingleWidgetManager.iframeUrls.PRODUCTION : SingleWidgetManager.iframeUrls.SANDBOX
  const hubbox = new SingleWidgetManager({
    deferRender: true, // Tells manager not to render iframe immediately
    iframeUrl,
    iframeParams: {
      showInformation: true,
      configId: 'themetalstore',
      locale: 'en-GB'
    }
  })

  const launchHubbox = () => {
    if (hubbox === null) {
      return console.error('Initialize HubBox first')
    }

    const hubboxModal: HTMLElement = document.getElementById('hubbox')
    const hubboxContainer: HTMLElement = document.getElementById('hubbox-pop-up')
    const hubboxCloseButton: HTMLElement = document.getElementById('hubbox-close-pop-up')

    if (hubboxModal) {
      hubboxModal.appendChild(hubbox.iframeElem)
    }

    const deliveryPostcodeEl = document.getElementById('delivery[postcode]')

    if (deliveryPostcodeEl) {
      hubbox.events.emit(hubbox.topics.emit.MAP_SEARCH_QUERY, deliveryPostcodeEl.value)
    }

    hubboxContainer.style.display = 'block'
    hubbox.events.subscribe(hubbox.topics.subscribe.COLLECT_POINT_CONFIRMED, onCollectPointConfirmed)

    hubboxCloseButton.addEventListener('click', closeHubbox)
  }

  const closeHubbox = () => {
    const hubboxContainer = document.getElementById('hubbox-pop-up')
    if (hubboxContainer) {
      hubboxContainer.style.display = 'none'
    }
  }

  const hasValidOpenDay = (openingHours) => {
    const hubboxModal: HTMLElement = document.getElementById('hubbox')
    const { deliveryDate } = hubboxModal.dataset
    const date = new Date(deliveryDate)
    const dayName = date.toLocaleDateString('en-GB', { weekday: 'long' })
    return openingHours[dayName.toLowerCase()]?.open !== 'Closed'
  }

  const onCollectPointConfirmed = async (event) => {
    const { message: { hubboxCollectPointId, openingHours } } = event
    closeHubbox()
    // Ensure that chosen collect point has at least one open day
    if (hasValidOpenDay(openingHours)) {
      const body = JSON.stringify({ hubbox_collect_point_id: hubboxCollectPointId })
      await fetch('/checkout/store_hubbox_checkout_details', optionsForFetch(body))
      window.location.reload()
    } else {
      return window.alert('The local pickup point you selected is not open on your chosen delivery date. Please select a different pickup point or change your delivery date on the basket page.')
    }
  }

  hubboxButton.addEventListener('click', launchHubbox)

  const token: string = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.getAttribute('content')

  const optionsForFetch = (body: BodyInit): RequestInit => ({
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': token
    },
    body,
    credentials: 'same-origin'
  })
}
